module.exports = __webpack_public_path__ + "media/flags/ie-flag-f783ccf1.svg";